import React from 'react';
import { makeStyles } from '@mui/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepButton from '@mui/material/StepButton';

const useStyles = makeStyles({
  root: {
    width: '100%',
    marginBottom: '2rem',
  },
  stepper: {
    backgroundColor: 'transparent',
  }
});

const steps = [
  { label: 'New', value: 'new' },
  { label: 'Upload Video', value: 'upload_video' },
  { label: 'Split Video', value: 'split_video' },
  { label: 'Grab Audio', value: 'grab_audio' },
  { label: 'Transcribe Audio', value: 'transcribe_audio' },
  { label: 'Identify Transcript Errors', value: 'identify_transcript_errors' },
  { label: 'Fix Transcript', value: 'fix_transcript' },
  { label: 'Sentence Building', value: 'sentence_building' },
  { label: 'Sentence Thought Fixing', value: 'sentence_thought_fixing' },
  { label: 'Translate to English', value: 'translate_to_english' },
  { label: 'Correct English', value: 'correct_english' },
  { label: 'Generate TTS', value: 'generate_tts' },
  { label: 'Per Language', value: 'per_language' },
];

const ProjectStepper = ({ currentStatus, onStepClick, readOnly = false }) => {
  const classes = useStyles();

  // Get the current step index
  const activeStep = steps.findIndex(step => step.value === currentStatus);

  // Function to determine if a step is completed
  const isStepCompleted = (index) => {
    return index < activeStep;
  };

  // Function to determine if a step can be clicked
  const isStepClickable = (index) => {
    return index <= activeStep;
  };

  const handleStep = (step) => {
    if (readOnly) return;
    if (isStepClickable(step)) {
      onStepClick(steps[step].value);
    }
  };

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}>
        {steps.map((step, index) => {
          const completed = isStepCompleted(index);
          const clickable = isStepClickable(index);

          return (
            <Step key={step.value} completed={completed}>
              <StepButton
                onClick={() => handleStep(index)}
                disabled={readOnly || !clickable}
              >
                <StepLabel>{step.label}</StepLabel>
              </StepButton>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};

export default ProjectStepper; 